interface FooterSectionProps {
  onCtaClick: (label: string) => void; // CTAクリックの関数を受け取る
}

export default function Footer({ onCtaClick }: FooterSectionProps) {
  return (
    <footer className="bg-clinic-green-dark text-white">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          <div>
            <h3 className="font-serif text-xl font-bold mb-3">
              <a 
                href="https://hiro-chiro-seitai.com/" 
                target="_blank" 
                rel="noopener noreferrer">ひろカイロ整体院</a>
            </h3>
            <p className="text-white/80 text-sm leading-relaxed">
              茨城県守谷市中央3-15-5<br />
              守谷駅徒歩1分、自律神経専門の整体院。<br />
              秋葉原駅からつくばエキスプレスで快速32分<br />
              めまい・頭痛・不眠の改善を<br />
              セロトニン活性療法でサポート。
            </p>
          </div>
          <div>
            <h4 className="font-bold text-sm mb-3">営業時間</h4>
            <ul className="text-white/80 text-sm space-y-1">
              <li>月火土：10:00〜13:00 / 15:30〜20:00</li>
              <li>金: 10:00〜13:00</li>
              <li>日: 10:00〜13:00 / 15:30〜17:00</li>
              <li>水曜・木曜：休診</li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-sm mb-2">お問い合わせ</h4>
            <a
              href="https://lin.ee/yWTagrY"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => onCtaClick('Footer_LINE')}
              className="inline-flex items-center gap-2 bg-green-500 hover:bg-green/90 text-white text-sm font-bold my-2 px-5 py-2.5 rounded-full transition-colors whitespace-nowrap"
            >
              <i className="ri-line-fill" />
              LINEで問い合わせる
            </a>
            <br />
            <a
              href="tel:0297-45-9659"
              onClick={() => onCtaClick('Footer_Tel')}
              className="inline-flex items-center gap-2 bg-white hover:bg-white/90 text-clinic-green-dark text-sm font-bold px-5 py-2.5 rounded-full transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-fill" />
              電話で問い合わせる
            </a>
          </div>
          <div>
            <h4 className="font-bold text-sm mb-2">公式ホームページ</h4>
            <a 
              href="https://hiro-chiro-seitai.com/" 
              target="_blank" 
              rel="noopener noreferrer">
                <img 
                  src="./images/logo_hirochiro.png" 
                  alt="ひろカイロ整体院のロゴ" 
                  className="w-44 mb-2 py-1 px-2 bg-white hover:bg-white/90 rounded-md object-contain" 
                />
                <p className="text-white/80 text-sm leading-relaxed">
                  https://hiro-chiro-seitai.com/
                </p>
            </a>
          </div>

        </div>
        <div className="border-t border-white/20 mt-8 pt-6 text-center">
          <p className="text-white/60 text-xs">
            <a href="https://hiro-chiro-seitai.com/" 
              target="_blank"
              rel="noopener noreferrer"
            >
                ひろカイロ整体院
            </a> All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}